"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinneProperties = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Fuehrungsrinne properties that are used by the individual applications.
 */
class FuehrungsrinneProperties {
}
exports.FuehrungsrinneProperties = FuehrungsrinneProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
FuehrungsrinneProperties[_a] = [
    'Id',
    'EchainId',
    'ArtNr',
    'BestTyp',
    'Bezeichnung',
    'Gewicht',
    'IsSet',
    'Opti',
    'Typ',
    'ZusBreiteAussenOhneMontageset',
    'IsSLH',
];
FuehrungsrinneProperties[_b] = [
    'Id',
    'EchainId',
    'ArtNr',
    'AuflageHoehe',
    'BefestigungInnenCProfil',
    'BestTyp',
    'Bezeichnung',
    'Gewicht',
    'IsSLH',
    'IsSet',
    'Opti',
    'Typ',
    'WidenBildId',
    'WidenZeichnungId',
    'ZusBreiteAussenOhneMontageset',
    'ZusBreiteBRi',
    'ZusBreiteFRBefestigungAussen',
    'ZusBreiteFRBefestigungInnen',
];
//# sourceMappingURL=FuehrungsrinneProperties.js.map